import React from 'react'

export default function TreasuryBonds() {
  return (
    <div>TreasuryBonds</div>
  )
}
